import React, { useEffect, useState } from 'react';

const CreateJobModal = ({ sites, defaultSiteId, onClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [siteId, setSiteId] = useState(defaultSiteId || sites[0]?.site_id || '');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (defaultSiteId) setSiteId(defaultSiteId);
  }, [defaultSiteId]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !siteId) return;
    onSubmit({ name, site_id: siteId, notes, status: 'draft' });
  };

  if (sites.length === 0) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal" onClick={(e) => e.stopPropagation()}>
          <h2>Create job</h2>
          <p className="empty-inline" style={{ marginBottom: 16 }}>Create a site first, then you can add jobs to it.</p>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" style={{ color: '#333', background: '#eee' }} onClick={onClose}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>Create job</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Job name</label>
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Spring Survey 2026" required />
          </div>
          <div className="form-group">
            <label>Site</label>
            <select value={siteId} onChange={(e) => setSiteId(e.target.value)} required>
              {sites.map((s) => (
                <option key={s.site_id} value={s.site_id}>{s.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Notes</label>
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Optional notes" />
          </div>
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary btn-touch" style={{ color: '#333', background: '#eee' }} onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary btn-touch">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateJobModal;
